<template>
  <div>
    <v-row dense class="mb-4">
      <v-col cols="auto">
        <v-btn
          outlined
          class="rounded-0"
          height="47"
          @click="toggleFilterPanel"
        >
          <v-icon>{{ icons.filter }}</v-icon>
          {{ $t('search.filter.label') }}
        </v-btn>
      </v-col>

      <v-col align-self="center">
        <span class="results-number" v-if="isLoading">{{ $t('search.loadings.search-in-progress') }}</span>
        <span
          class="results-number"
          v-else
        >
          {{ numberOfResults }} {{ $tc('search.results.number', numberOfResults) }}
        </span>
      </v-col>

      <v-col sm="auto" cols="12">
        <v-btn
          outlined
          class="rounded-0"
          height="47"
          :block="$vuetify.breakpoint.mdAndDown"
          :to="`${locale}/my-venues`"
        >
          <v-icon>{{ icons.bookmark }}</v-icon>
          {{ $t('search.see-list') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <VenuesFilterPanel
          ref="venues-filter-panel"
          :is-fetching="isFetching"
          :is-open="filters.venuesPanelIsOpen"
          :all-pois="allPois"
          @filter="filterPois"
        />
      </v-col>
    </v-row>

    <v-row v-if="isLoading">
      <v-col
        v-for="i in 9"
        :key="i"
        cols="12"
        sm="6"
        lg="4"
      >
        <ResultThumbnailSkeleton/>
      </v-col>
    </v-row>

    <ResultThumbnails
      v-else
      :filtered-pois="filteredPois"
      @onHover="onHover"
    />
  </div>
</template>

<script>
  import VenuesFilterPanel from './VenuesFilterPanel.vue'
  import ResultThumbnails from './ResultThumbnails.vue'
  import ResultThumbnailSkeleton from './ResultThumbnailSkeleton.vue'

  import { mdiBookmarkOutline, mdiTune, mdiUpdate } from '@mdi/js'

  export default {
    name: 'SearchContainer',

    props: {
      filteredPois: {
        required: true,
        type: Array,
      },

      isFetching: {
        required: true,
        type: Boolean,
      },

      isLoading: {
        required: true,
        type: Boolean,
      },
    },

    data() {
      return {
        icons: {
          filter: mdiTune,
          bookmark: mdiBookmarkOutline,
          sync: mdiUpdate,
        },

        filters: {
          venuesPanelIsOpen: false,
        },
      }
    },

    components: {
      VenuesFilterPanel,
      ResultThumbnails,
      ResultThumbnailSkeleton,
    },

    computed: {
      isOnline() {
        return this.$store.state.isOnline
      },

      allPois() {
        return this.$store.state.objects.pois
      },

      numberOfResults() {
        return this.filteredPois.length
      },

      locale() {
        return this.$store.state.locale
      },
    },

    methods: {
      toggleFilterPanel() {
        this.filters.venuesPanelIsOpen = !this.filters.venuesPanelIsOpen

        if (this.filters.venuesPanelIsOpen) {
          this.$nextTick(() => this.scrollToResult())
        }
      },

      filterPois(pois) {
        this.$emit('filterPois', pois)
      },

      onHover(id) {
        this.$emit('onHover', id)
      },

      scrollToResult() {
        document.getElementById('filter-panel').scrollIntoView()
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"
  @import "@/assets/styles/_mixins.sass"

  .v-btn
    @include basic-btn

  .v-icon
    margin-right: 5px

  .results-number
    margin-left: 10px
    font-family: "EuclidMedium"
    color: $gray
    font-size: 14.4px
</style>
